/**
 * The event page's Join, floating above the tab dock (Sam, 2026-10-31): Join before you RSVP, Going (a tap opens your
 * RSVP) after. Only that - Tickets, Map and Share stay on the page under the venue.
 *
 * A compact chip in the middle (Sam's B), built from the app's own buttons: Join is the primary Button, Going the
 * secondary one with a check. Its only additions are the pill shape and the dark glass backing the tiles' buttons wear
 * (index.css .rsvp-bar__btn), so it reads over whatever scrolls under it.
 *
 * It sits above the now-playing bar: a Spotify preview keeps its place over the dock on every music page, so the
 * button rises over it rather than the preview jumping when you open an event.
 */
import { useLayoutEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { Check, Plus } from 'lucide-react';
import Button from '../ui/Button';

export default function EventRsvpBar({ going, loading, glowClass = '', onRsvp }) {
  const ref = useRef(null);

  // The page makes room for it, as it does for the now-playing bar (pb-app-content)
  useLayoutEffect(() => {
    const root = document.documentElement;
    const h = ref.current ? ref.current.getBoundingClientRect().height + 10 : 0;
    root.style.setProperty('--rsvp-bar-h', `${Math.round(h)}px`);
    return () => root.style.setProperty('--rsvp-bar-h', '0px');
  }, [going]);

  return createPortal(
    <div ref={ref} className="rsvp-bar">
      {going ? (
        <Button
          variant="secondary"
          size="lg"
          className="rsvp-bar__btn rsvp-bar__btn--going"
          onClick={onRsvp}
          loading={loading}
        >
          <span className="rsvp-bar__check" aria-hidden>
            <Check size={16} strokeWidth={3} />
          </span>
          <span className="rsvp-bar__text">
            <b>Going</b>
            <small>Edit your RSVP</small>
          </span>
        </Button>
      ) : (
        <Button
          size="lg"
          className={`rsvp-bar__btn ${glowClass}`}
          onClick={onRsvp}
          loading={loading}
          // A + like the tiles' Join (Sam, 2026-11-04; was a group icon)
          leftIcon={<Plus size={18} strokeWidth={2.6} aria-hidden />}
          data-moment="rsvp"
        >
          Join
        </Button>
      )}
    </div>,
    // In the app's layer (Layout), not body: the launch splash is on top inside it, and a body portal drew over the splash
    document.getElementById('app-layer') || document.body,
  );
}
